/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { Button } from '@mui/material';
import appTheme from '../theme/appTheme.json';
import React from 'react';
import { useFormikContext } from 'formik';

export interface BeamSubmitProps {
  text?: string;
  width?: string;
}

export const BeamSubmitButton = ({ text="Submit", width="100px" }: BeamSubmitProps) => {
  const formikContext = useFormikContext();
  return (
    <Button
      variant="contained"
      disabled={formikContext.isSubmitting}
      sx={{
        backgroundColor: appTheme.mptLightBlue,
        color: '#000000',
        '&:hover': {
          backgroundColor: appTheme.mptLightBlue,
        },
        height: '40px',
        width,
      }}
      type={'submit'}
    >
      {text}
    </Button>
  );
};
